import {ExamModule, QuestionCheckInput} from '@cp/model';
import {QuestionFormData} from '../../../types/QuestionFormData';

/**
 * Map QuestionFormData to QuestionCheckInput for validation
 * Finds the topic in examModules to get category and detail
 */
export default function mapQuestionDataToQuestionCheckInput(
  formData: QuestionFormData,
  examModules: ExamModule[],
): QuestionCheckInput | null {
  // Validate required fields
  if (
    !formData.moduleId ||
    !formData.questionText.trim() ||
    !formData.answer.trim() ||
    !formData.topic.trim() ||
    !formData.explanation.trim()
  ) {
    return null;
  }

  const filteredOptions = formData.options.filter((option) => option.trim());
  if (filteredOptions.length < 2) {
    return null;
  }

  // Find the module and topic to get category and detail
  const selectedModule = examModules.find((module) => module.id === formData.moduleId);
  const selectedTopic = selectedModule?.topics.find((topic) => topic.topic === formData.topic);

  if (!selectedTopic) {
    return null;
  }

  return {
    moduleTopic: {
      topic: selectedTopic.topic,
      category: selectedTopic.category,
      detail: selectedTopic.detail || undefined,
    },
    difficulty: formData.difficulty,
    questionText: formData.questionText.trim(),
    hint: formData.hint?.trim() || undefined,
    options: filteredOptions,
    answer: formData.answer.trim(),
    explanation: formData.explanation.trim(),
  };
}
